import { render, staticRenderFns } from "./fulfillment-new-current-requests.vue?vue&type=template&id=43a0e328"
import script from "./fulfillment-new-current-requests.vue?vue&type=script&lang=js"
export * from "./fulfillment-new-current-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports